import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

import { FaMicrosoft } from 'react-icons/fa';

import { StyledMicrosoftButton } from './styles';

function MicrosoftLoginButton({ onClick, disabled, loading }) {
  return (
    <StyledMicrosoftButton
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      ) : (
        <FaMicrosoft size={18} color="#5e5e5e" />
      )}
      Entrar com Microsoft
    </StyledMicrosoftButton>
  );
}

export default MicrosoftLoginButton;
